var classNames = require("classnames");
var ReactSelect = require("react-select").default;
var Components = require("react-select").components;
var Createable = require("react-select").Creatable;

class ClearIndicator extends React.Component {
	render() {
		return (
			<span ref={this.props.innerRef} {...this.props.innerProps} className="Select-clear-zone" title="Clear all" aria-label="Clear all">
				<span className="Select-clear">x</span>
			</span>
		);
	}
}

class DropdownIndicator extends React.Component {
	render() {
		return (
			<span ref={this.props.innerRef} {...this.props.innerProps} className="Select-arrow-zone">
				<span className="Select-arrow"></span>
			</span>
		);
	}
}

class IndicatorsContainer extends React.Component {
	render() {
		return this.props.children;
	}
}

class IndicatorSeparator extends React.Component {
	render() {
		return (
			null
		);
	}
}

class Input extends React.Component {
	render() {
		return (
			<div className="Select-input-wrapper">
				<Components.Input
					{...this.props}
					className="Select-input"
					style={{ display: "inline-block" }}
				/>
			</div>
		);
	}
}

class MultiValueContainer extends React.Component {
	render() {
		return (
			<div ref={this.props.innerRef} {...this.props.innerProps} className="Select-value">
				{this.props.children[1]}
				{this.props.children[0]}
			</div>
		);
	}
}

class MultiValueLabel extends React.Component {
	render() {
		var data = this.props.data;
		var label = typeof(data) === "string" ? data : (data && data.label);
		return (
			<span ref={this.props.innerRef} {...this.props.innerProps} className="Select-value-label">
				{label}
				<span className="Select-aria-only">&nbsp;</span>
			</span>
		);
	}
}

class MultiValueRemove extends React.Component {
	render() {
		return (
			<span ref={this.props.innerRef} {...this.props.innerProps} className="Select-value-icon">x</span>
		);
	}
}

class Option extends React.Component {
	handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();

		if (this.props.isDisabled) {
			return;
		}

		this.props.innerProps.onClick(this.props.data, event);
	}

	handleMouseEnter(event) {
		if (this.props.isDisabled) {
			return;
		}

		this.props.innerProps.onMouseOver(this.props.data, event);
	}

	handleMouseMove(event) {
		if (this.props.isFocused || this.props.isDisabled) {
			return;
		}

		this.props.innerProps.onMouseMove(this.props.data, event);
	}

	render() {
		var props = this.props;
		var label = typeof(props.data) === "string" ? props.data : (props.data && props.data.label);

		return (
			<div ref={this.props.innerRef} {...props.innerProps} className={classNames(
				"Select-option",
				props.isSelected && "is-selected",
				props.isFocused && "is-focused",
				props.isDisabled && "is-disabled"
			)}
				onMouseDown={this.handleMouseDown.bind(this)}
				onMouseEnter={this.handleMouseEnter.bind(this)}
				onMouseMove={this.handleMouseMove.bind(this)}
			>
				{props.selectProps.hasValueDescriptionOptions &&
					<div className="row">
						<div className="col-xs-4">
							{props.children}
						</div>
						<div className="col-xs-8">
							<span className="label label-default">{label}</span>
						</div>
					</div>
				}
				{!props.selectProps.hasValueDescriptionOptions && props.children}
			</div>
		);
	}
}

class Placeholder extends React.Component {
	render() {
		return (
			<div ref={this.props.innerRef} {...this.props.innerProps} className="Select-placeholder">
				{this.props.selectProps.placeholder || this.props.children}
			</div>
		)
	}
}

class SelectContainer extends React.Component {
	render() {
		return (
			<Components.SelectContainer
				{...this.props}
				className={classNames(
					"Select",
					this.props.className,
					this.props.selectProps.isMulti ? "Select--multi" : "Select--single",
					this.props.selectProps.isSearchable && "is-searchable",
					this.props.selectProps.isDisabled && "is-disabled",
					this.props.hasValue && "has-value"
				)}
			>
				{this.props.children}
			</Components.SelectContainer>
		);
	}
}

class SingleValue extends React.Component {
	render() {
		var label = this.props.data && this.props.data.label;
		return (
			<div className="Select-value">
				<span className="Select-value-label">
					{this.props.children}
					{this.props.selectProps.hasValueDescriptionOptions &&
						<span className="label label-default" style={{ marginLeft: 5 }}>{label}</span>
					}
				</span>
			</div>
		);
	}
}

class ValueContainer extends React.Component {
	render() {
		return (
			<span ref={this.props.innerRef} {...this.props.innerProps} className="Select-multi-value-wrapper">
				{this.props.children}
			</span>
		);
	}
}

class Control extends React.Component {
	render() {
		return (
			<div ref={this.props.innerRef} {...this.props.innerProps} className="Select-control">
				{this.props.children}
			</div>
		);
	}
}

class Select extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		var components = {
			ClearIndicator,
			Control,
			DropdownIndicator,
			IndicatorsContainer,
			IndicatorSeparator,
			Input,
			MultiValueContainer,
			MultiValueLabel,
			MultiValueRemove,
			Option,
			Placeholder,
			SelectContainer,
			SingleValue,
			ValueContainer,
		};

		return this.props.isCreatable ? (
			<Createable
				{...this.props}
				components={components}
				closeMenuOnSelect={!this.props.isMulti}
			/>
		) : (
			<ReactSelect
				{...this.props}
				components={components}
				inputValue={this.state.inputValue}
				onInputChange={(inputValue) => this.setState({ inputValue })}
				closeMenuOnSelect={!this.props.isMulti}
			/>
		);
	}
}

Select.defaultProps = {};

module.exports = Select;
